// extracted by mini-css-extract-plugin
module.exports = {"cus-mtdicon":"h7","cusMtdicon":"h7"};